<template>
  <div>
    <div class="ai-context-ghost" :class="{open: expanded}" @click="expanded = !expanded">
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
      <span class="ai-context-ghost-txt">{{ ghostText }}</span>
      <span class="ai-context-ghost-badge">{{ configured ? 'Đã cấu hình' : 'Chưa cấu hình' }}</span>
      <svg class="ai-context-chevron" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
    </div>
    <div class="ai-context-detail" :class="{open: expanded}">
      <div v-if="!configured" class="ai-context-empty">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
        Chưa có cấu hình doanh nghiệp. Bấm
        <a href="#" @click.prevent="$emit('open-setup')">Cài đặt doanh nghiệp</a>
        để AI phân tích chính xác hơn.
      </div>
      <template v-else>
        <div class="ai-context-item">
          <span class="ai-context-dot" style="background:var(--purple)"></span>
          <div>
            <div class="ai-context-lbl">Vai trò AI</div>
            <div class="ai-context-val">{{ roleText }}</div>
          </div>
        </div>
        <div class="ai-context-item" style="margin-top:8px">
          <span class="ai-context-dot" style="background:var(--acc)"></span>
          <div>
            <div class="ai-context-lbl">Bối cảnh doanh nghiệp</div>
            <div class="ai-context-val">{{ contextText }}</div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SaleAIAiContext',
  props: {
    data: { type: Object, default: null },
  },
  data() {
    return { expanded: false };
  },
  computed: {
    parsed() {
      const d = this.data;
      if (!d) return null;
      // Saved-config shape expected:
      // { industry: { industry: [{code,display}], industryDetails, businessSize },
      //   customerSegment: { customerTypes: [{code,display}], customerSegment, customerDescription } }
      const ind = d.industry && typeof d.industry === 'object' && Array.isArray(d.industry.industry)
        ? d.industry : null;
      const seg = d.customerSegment && typeof d.customerSegment === 'object' ? d.customerSegment : null;
      if (!ind && !seg) return null;
      return {
        industries: ind ? (ind.industry || []).map(i => i.display).filter(Boolean) : [],
        industryDetails: ind ? (ind.industryDetails || '') : '',
        businessSize: ind ? (ind.businessSize || '') : '',
        customerTypes: seg ? (seg.customerTypes || []).map(c => c.display).filter(Boolean) : [],
        customerSegment: seg ? (seg.customerSegment || '') : '',
        customerDescription: seg ? (seg.customerDescription || '') : '',
      };
    },
    configured() {
      return !!this.parsed;
    },
    ghostText() {
      if (!this.parsed) return 'AI: chưa cấu hình doanh nghiệp';
      const ind = this.parsed.industries[0] || this.parsed.industryDetails || 'Đa ngành';
      const seg = this.parsed.customerSegment || (this.parsed.customerTypes[0] || '');
      return 'AI: Chuyên gia ' + ind + (seg ? ' · ' + seg : '');
    },
    roleText() {
      if (!this.parsed) return '';
      const ind = this.parsed.industries.join(', ') || this.parsed.industryDetails || 'đa ngành';
      const customer = this.parsed.customerTypes.join(', ') || 'khách hàng';
      return 'Chuyên gia phân tích CRM trong lĩnh vực ' + ind + ', phục vụ ' + customer + '.';
    },
    contextText() {
      if (!this.parsed) return '';
      const parts = [];
      if (this.parsed.industryDetails) parts.push('Lĩnh vực chi tiết: ' + this.parsed.industryDetails);
      if (this.parsed.businessSize) parts.push('Quy mô: ' + this.parsed.businessSize);
      if (this.parsed.customerSegment) parts.push('Phân khúc: ' + this.parsed.customerSegment);
      if (this.parsed.customerDescription) parts.push('KH lý tưởng: ' + this.parsed.customerDescription);
      return parts.join(' · ') || 'Chưa có mô tả bối cảnh.';
    },
  },
};
</script>
